export default function auth(from, to, next) {
    if (!localStorage.getItem('token')) {
        next({
            name: "Login"
        })
    }
  
    return next();
  }